import React, { useState } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import TermsOfUseContent from 'app/containers/TermsOfUsePage/content';

/**
 * Modal to display Terms of Use
 * @returns {JSX.Element}
 */
function ModalTermsOfUse({ onAcceptClick }) {
  const [open, setOpen] = useState(false);

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleAccept = (event) => {
    setOpen(false);
    onAcceptClick?.();
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      trigger={
        <button type="button" className="ui link" onClick={handleClick}>
          <FormattedMessage id="terms-of-use.title" />
        </button>
      }
      className="terms-of-use-modal"
    >
      <Modal.Header>
        <FormattedMessage id="terms-of-use.title" />
        <br />
        <small>
          <FormattedMessage id="terms-of-use.sub-title" />
        </small>
      </Modal.Header>
      <Modal.Content scrolling>
        <Modal.Description>
          <TermsOfUseContent />
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={handleAccept}>
          <FormattedMessage id="billing.accept-terms-of-sales" /> <Icon name="right chevron" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default ModalTermsOfUse;
